
export function SyncWithLocationButton() {
  return null
  // const { openSelectMusicDialog } = useSelectMusicDialog()
  // const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  // const { screens, updateScreen } = useScreens()
  // const { screenInfo } = useScreen()
  // const { showErrorSnackbar, showSuccessSnackbar, closeDialog } = useDialog()
  // const mutation = useMusicGroupQuery.upsert()
  // const removeMutation = useMusicGroupQuery.removeFromGroup()
  // const { locations } = useLocations()
  // const queryClient = useQueryClient()
  // const { controlInfo } = useMusicControl(screenInfo?.id!, screenInfo?.locationId)

  // const handleSync = async () => {
  //   if (!screenInfo?.locationId) {
  //     return showErrorSnackbar("No location associated with this screen")
  //   }

  //   if (!screenInfo.zone_id) {
  //     return showErrorSnackbar("No zone associated with this screen")
  //   }

  //   const location = locations.find(l => l.id === screenInfo.locationId)
  //   const locationScreens = screens.filter(s => s.location_id === screenInfo.locationId)
  //   const firstScreenWithGroup = locationScreens.find(s => !!s.group_id)
  //   if (!location?.id_code) {
  //     return showErrorSnackbar("No location code associated with this location")
  //   }
  //   mutation.mutate({
  //     groupId: firstScreenWithGroup?.group_id ?? undefined,
  //     currentLocationId: location?.id_code,
  //     name: location?.name ? `${location.name} Locations` : "Unknown Location",
  //     locations: [location.id_code],
  //   }, {
  //     async onSuccess(res) {
  //       // Create music control record for the screen as owner only if it's the first screen with a group
  //       const isFirstScreenWithGroup = !firstScreenWithGroup || firstScreenWithGroup.id === screenInfo.id;
  //       await supabase
  //         .from('music_control')
  //         .upsert({
  //           screen_id: screenInfo.id ?? "",
  //           location_id: screenInfo.locationId ?? "",
  //           is_owner: isFirstScreenWithGroup,
  //           has_control: isFirstScreenWithGroup,
  //           request_status: null,
  //           requested_at: null,
  //         })
  //         .select()
  //         .single();

  //       updateScreen({
  //         screenId: screenInfo.id ?? "",
  //         data: {
  //           group_id: res?.id ?? firstScreenWithGroup?.group_id,
  //           playlist_id: firstScreenWithGroup?.playlist_id,
  //           music_playing: firstScreenWithGroup?.music_playing,
  //           last_music_id: firstScreenWithGroup?.last_music_id,
  //           // @ts-expect-error
  //           group_music_infos: [{ url: res?.url ?? firstScreenWithGroup?.group_music_infos?.[0]?.url }]
  //         }
  //       })
  //       showSuccessSnackbar("Successfully synced music with location")
  //       const screen = screens.find(s => s.id === screenInfo.id)!
  //       openSelectMusicDialog({
  //         screen: { ...screen, group_id: res?.id ?? firstScreenWithGroup?.group_id ?? null },
  //       })

  //       // Invalidate music control queries
  //       queryClient.invalidateQueries({ queryKey: ['music-control'] })

  //       if (!isFirstScreenWithGroup) {
  //         closeDialog()
  //       }
  //     },
  //     onError(error) {
  //       showErrorSnackbar("Failed to sync music with location")
  //       console.error(error)
  //     }
  //   })
  // }

  // return (
  //   <>
  //     <Button
  //       variant="outline"
  //       onClick={screenInfo?.group_id ? () => setRemoveDialogOpen(true) : handleSync}
  //       disabled={mutation.isPending || removeMutation.isPending}
  //     >
  //       {
  //         (mutation.isPending || removeMutation.isPending) && (
  //           <Loader2 className="animate-spin h-5 w-5 text-gray-500" />
  //         )
  //       }
  //       {screenInfo?.group_id ? "Unsync Music" : "Sync with Location"}
  //     </Button>

  //     <AlertDialog open={removeDialogOpen} onOpenChange={setRemoveDialogOpen}>
  //       <AlertDialogContent>
  //         <AlertDialogHeader>
  //           <AlertDialogTitle>Unsync Music</AlertDialogTitle>
  //           <AlertDialogDescription>
  //             {screens.find(s => s.id === screenInfo?.id)?.group_id && screens.some(s => s.location_id === screenInfo?.locationId && s.id !== screenInfo?.id && s.group_id) ? (
  //               <>This screen is currently controlling music for this location. Unsyncing will disable music sync for all screens in this location. Are you sure you want to continue?</>
  //             ) : (
  //               <>Are you sure you want to unsync music from this location? This will remove all music control settings for this screen.</>
  //             )}
  //           </AlertDialogDescription>
  //         </AlertDialogHeader>
  //         <AlertDialogFooter>
  //           <AlertDialogCancel>Cancel</AlertDialogCancel>
  //           <AlertDialogAction
  //             onClick={() => {
  //               if (!screenInfo?.group_id) {
  //                 return showErrorSnackbar("No group associated with this screen")
  //               }

  //               const isController = controlInfo?.is_owner;

  //               const affectedScreens = isController ?
  //                 screens.filter(s => s.location_id === screenInfo?.locationId && s.group_id) :
  //                 [screens.find(s => s.id === screenInfo?.id)!];

  //               removeMutation.mutate({
  //                 groupId: screenInfo.group_id,
  //                 screenWithSameGroupCount: screens.filter(s => s.group_id === screenInfo.group_id).length,
  //               }, {
  //                 async onSuccess() {
  //                   // Delete music control records for all affected screens
  //                   await supabase
  //                     .from('music_control')
  //                     .delete()
  //                     .in('screen_id', affectedScreens.map(s => s.id))
  //                     .eq('location_id', screenInfo.locationId ?? "");

  //                   // Update all affected screens
  //                   await Promise.all(affectedScreens.map(screen =>
  //                     updateScreen({
  //                       screenId: screen.id,
  //                       data: {
  //                         group_id: null,
  //                         playlist_id: null,
  //                         music_playing: false,
  //                         last_music_id: null,
  //                         group_music_infos: null
  //                       }
  //                     })
  //                   ));

  //                   showSuccessSnackbar(isController ?
  //                     "Successfully unsynced music for all screens in this location" :
  //                     "Successfully unsynced music from location"
  //                   );

  //                   const currentScreen = screens.find(s => s.id === screenInfo.id)!;
  //                   openSelectMusicDialog({
  //                     screen: {
  //                       ...currentScreen,
  //                       group_id: null,
  //                       playlist_id: null,
  //                       music_playing: false,
  //                       last_music_id: null,
  //                       group_music_infos: null
  //                     },
  //                   })

  //                   // Invalidate music control queries
  //                   queryClient.invalidateQueries({ queryKey: ['music-control'] })
  //                 },
  //                 onError(error) {
  //                   showErrorSnackbar("Failed to unsync music from location")
  //                   console.error(error)
  //                 }
  //               })
  //             }}
  //           >
  //             Unsync
  //           </AlertDialogAction>
  //         </AlertDialogFooter>
  //       </AlertDialogContent>
  //     </AlertDialog>
  //   </>
  // )
}